import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import './style.scss';

/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
const Color = ({ color, isSelected, onSelect }) => (
  <li
    style={{ backgroundColor: color }}
    data-color={color}
    styleName={cn('color', {
      'is-selected': isSelected,
    })}
    onClick={onSelect}
  />
);

Color.propTypes = {
  color: PropTypes.string,
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func,
};

export default Color;
